import { render, staticRenderFns } from "./CourseModal.vue?vue&type=template&id=6d66f613&scoped=true"
import script from "./CourseModal.vue?vue&type=script&lang=js"
export * from "./CourseModal.vue?vue&type=script&lang=js"
import style0 from "./CourseModal.css?vue&type=style&index=0&id=6d66f613&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d66f613",
  null
  
)

export default component.exports